var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery"},[_c('Carousel',{staticClass:"carousel",attrs:{"navigationEnabled":true,"perPage":1,"perPageCustom":[
        [600, 2],
        [800, 3],
        [1000, 4]
      ],"paginationEnabled":false}},_vm._l((_vm.items),function(item){return _c('Slide',{key:item.id,staticClass:"slide"},[_c('Item',{attrs:{"item":item},on:{"selected":_vm.itemSelected}})],1)}),1),_c('Overlay',{attrs:{"active":!!_vm.selectedItem.url},on:{"close":_vm.onOverlayClose}},[_c('LazyImg',{staticClass:"image",attrs:{"url":_vm.selectedItem.url,"description":"selectedItem.description"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }